import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PackageService {


 url = environment.apiUrl;
  
  constructor(private httpClient: HttpClient) { }
 

  getAllPackages() {
    return this.httpClient.get(this.url + '/plans');
  }
  getActiveSubscription() {
    return this.httpClient.get(this.url + '/plans/subscriptions/active-subscription');
  }
  getAllSubscription() {
    return this.httpClient.get(this.url + '/plans/subscriptions');
  }
  cancelActiveSubscription(filters) {
    return this.httpClient.post(this.url + '/plans/subscriptions/cancel',filters);
  }
  getInvoices() {
    return this.httpClient.get(this.url + '/plans/subscriptions/invoices');
  }
  getPackageSummary(filters) {
    return this.httpClient.post(this.url + '/plans/subscribe/summary', filters );
  }
  getPaymentUrl(filters) {
    return this.httpClient.post(this.url + '/plans/subscribe/payment-url', filters );
  }
 
}
